import React from 'react';

const IndInvestmentAdvisers = ({ formData, handleChange, fieldErrors }) => {
    return (
        <div>
            <h4>
                *Note that the ability to give a response of “True” to any part of the question below qualifies the Subscriber as a “qualified client” under the United States Investment Advisers Act of 1940, as amended, and the rules and regulations promulgated thereunder.
            </h4>

            <fieldset className="form-field">
                <legend>
                    The natural person described in Part I(a) above (please respond to each):
                </legend>

                <fieldset className="form-field">
                    <legend>
                        (a) has a net worth (including assets held jointly with such person’s spouse) in excess of $2,200,000, excluding the value of the primary residence of such person, calculated by subtracting from the estimated fair market value of the property the amount of debt secured by the property up to the estimated fair market value of the property;
                    </legend>
                    <label><input type="radio" name="investmentAdvisers.netWorth2" value="true" checked={formData?.investmentAdvisers?.netWorth2 === 'true'} onChange={handleChange} required/>
                        True
                    </label><br/>
                    <label><input type="radio" name="investmentAdvisers.netWorth2" value="false" checked={formData?.investmentAdvisers?.netWorth2 === 'false'} onChange={handleChange}/>
                        False
                    </label>
                </fieldset>

                <fieldset className="form-field">
                    <legend>
                        (b) is making a commitment to the Fund of at least $1,100,000 or, immediately after making a contribution to the Fund, will have at least $1,100,000 under the management of the Management Company;
                    </legend>
                    <label><input type="radio" name="investmentAdvisers.highCommit" value="true" checked={formData?.investmentAdvisers?.highCommit === 'true'} onChange={handleChange} required/>
                        True
                    </label><br/>
                    <label><input type="radio" name="investmentAdvisers.highCommit" value="false" checked={formData?.investmentAdvisers?.highCommit === 'false'} onChange={handleChange}/>
                        False
                    </label>
                </fieldset>

                
                <fieldset className="form-field">
                    <legend>
                    (c) is a “qualified purchaser” as defined in Section 2(a)(51)(A) of the U.S. Investment Company Act of 1940, as amended, and the rules and regulations promulgated thereunder (i.e., such person owns at least $5,000,000 of Investments as defined in Appendix A hereto).
                    </legend>
                    <label><input type="radio" name="investmentAdvisers.qualPurchaser" value="true" checked={formData?.investmentAdvisers?.qualPurchaser === 'true'} onChange={handleChange} required/>
                    True
                    </label><br />
                    <label><input type="radio" name="investmentAdvisers.qualPurchaser" value="false" checked={formData?.investmentAdvisers?.qualPurchaser === 'false'} onChange={handleChange} />
                    False
                    </label>

                    {fieldErrors?.["investmentAdvisers.qualPurchaser"] && (
                    <div className="error-message" style={{ color: 'red', fontWeight: 'bold', marginTop: '0.5rem' }}>
                        {fieldErrors["investmentAdvisers.qualPurchaser"]}
                    </div>
                    )}
                </fieldset>
                
            </fieldset>
        </div>
    );
};

export default IndInvestmentAdvisers;
